// Troca de tema com cortina de cima para baixo e borda esfumada (View Transitions API).
// Sem suporte no navegador ou com "reduzir movimento" ativo, aplica a troca direto.
const DARK_CSS_ID = 'theme-dark-css';
const DURATION = 560;
const EASING = 'cubic-bezier(0.65, 0, 0.25, 1)';

function waitDarkCss() {
    const link = document.getElementById(DARK_CSS_ID);
    if (!link || link.sheet) return Promise.resolve();
    return new Promise(resolve => {
        link.addEventListener('load', resolve, {once: true});
        link.addEventListener('error', resolve, {once: true});
        setTimeout(resolve, 1500);
    });
}

export default function themeTransition(event, apply) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!document.startViewTransition || reduceMotion) {
        apply();
        return;
    }

    const transition = document.startViewTransition(async () => {
        await apply();
        await waitDarkCss();
    });

    transition.ready.then(() => {
        // fill 'forwards' segura o quadro final até a transição ser removida (evita piscar no fim)
        const options = {duration: DURATION, easing: EASING, fill: 'forwards', pseudoElement: '::view-transition-new(root)'};
        // Tela nova desce como cortina; a máscara (gradiente com a borda esfumada) é definida no theme.css.
        // Sem mask animável, a cortina desce com recorte reto.
        const curtain = CSS.supports('mask-size', '1px')
            ? {maskSize: ['100% 0%', '100% 130%']}
            : {clipPath: ['inset(0 0 100% 0)', 'inset(0 0 0 0)']};
        const animation = document.documentElement.animate(curtain, options);
        transition.finished.finally(() => animation.cancel());
    }).catch(() => {});
}
